import React from "react"

import { AppIconChipToggle } from "@components"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { boolean, object } from "yup"


export default function ReportWebSuppliersExclusionSwitch() {
	const {
		filterWebSuppliersExclusion,
		setFilterWebSuppliersExclusionInfo,
	} = useReportFormInfo(reportFormData.peek().filterWebSuppliersExclusion, "filterWebSuppliersExclusion", object({ filterWebSuppliersExclusion: boolean() }))

	return <AppIconChipToggle
		aria-label="Web suppliers"
		value={!!filterWebSuppliersExclusion}
		options={[
			{ value: false, label: 'Include', icon: 'check' },
			{ value: true, label: 'Exclude', icon: 'ban' },
		]}
		onChange={value => setFilterWebSuppliersExclusionInfo(value)}
	/>
}